import actions from './actions';

const {
  GET_CUSTOMER_INTEREST_BEGIN, GET_CUSTOMER_INTEREST_SUCCESS, GET_CUSTOMER_INTEREST_FAILED,
  ADD_CUSTOMER_INTEREST_BEGIN, ADD_CUSTOMER_INTEREST_SUCCESS, ADD_CUSTOMER_INTEREST_FAILED,
  UPDATE_CUSTOMER_INTEREST_BEGIN, UPDATE_CUSTOMER_INTEREST_SUCCESS, UPDATE_CUSTOMER_INTEREST_FAILED,
  DELETE_CUSTOMER_INTEREST_BEGIN, DELETE_CUSTOMER_INTEREST_SUCCESS, DELETE_CUSTOMER_INTEREST_FAILED
} = actions;

const initState = {
  total: 0,
  interests: [],
  currentPage: 1,
  pageLimit: 50,
  loading: false,
  error: null,
};


const CustomerInterestReducer = (state = initState, action) => {
  const { type, data, err } = action;
  switch (type) {
    case GET_CUSTOMER_INTEREST_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case GET_CUSTOMER_INTEREST_SUCCESS:
      return {
        ...state,
        total: data.total || 0,
        interests: data.userRequirements,
        currentPage: data.currentPage || state.currentPage,
        pageLimit: data.pageLimit || state.pageLimit,
        loading: data.currentPage ? false : true,
      };
    case GET_CUSTOMER_INTEREST_FAILED:
      return {
        ...state,
        error: err,
        loading: false,
      };
    case ADD_CUSTOMER_INTEREST_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case ADD_CUSTOMER_INTEREST_SUCCESS:
      return {
        ...state,
        total: data.total + 1,
        interests: data,
        loading: false,
      };
    case ADD_CUSTOMER_INTEREST_FAILED:
      return {
        ...state,
        error: err,
        loading: false,
      };
    case UPDATE_CUSTOMER_INTEREST_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case UPDATE_CUSTOMER_INTEREST_SUCCESS:
      return {
        ...state,
        interests: data,
        loading: false,
      };
    case UPDATE_CUSTOMER_INTEREST_FAILED:
      return {
        ...state,
        error: err,
        loading: false,
      };
    case DELETE_CUSTOMER_INTEREST_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case DELETE_CUSTOMER_INTEREST_SUCCESS:
      return {
        ...state,
        total: data.total - 1,
        interests: data,
        loading: false,
      };
    case DELETE_CUSTOMER_INTEREST_FAILED:
      return {
        ...state,
        error: err,
        loading: false,
      };
    default:
      return state;
  }
};
export default CustomerInterestReducer;